import React from "react";
import * as PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { css } from "@emotion/css";
// import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import ProgressButton from "../ProgressButton";

const classes = {
    actionButton: css`
        margin-top: 20px;
        width: fit-content;
    `,
    name: css`
        display: block;
        width: 400px;
    `,
};

const PrepareDataSaver = ({ t, ...rest }) => (
    <div>
        <TextField
            label={t("Data set name")}
            placeholder={t("Specify name for data set...")}
            InputLabelProps={{
                shrink: true,
            }}
            fullWidth={true}
            value={rest.name || ""}
            className={classes.name}
            onChange={(e) => {
                rest.onChangeName(e.target.value);
            }}
        />

        <ProgressButton
            variant="contained"
            disabled={rest.saveDisabled || rest.saving}
            loading={rest.saving}
            className={classes.actionButton}
            onClick={rest.onSave}
        >
            {t("Save")}
        </ProgressButton>

        {/* <Button
            variant="contained"
            color="primary"
            disabled={rest.saveDisabled}
            className={classes.actionButton}
            onClick={rest.onSave}
        >
            {t("Save")}
        </Button> */}
    </div>
);

PrepareDataSaver.propType = {
    name: PropTypes.string,
    saveDisabled: PropTypes.bool,
    onChangeName: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
};

PrepareDataSaver.defaultProps = {
    saveDisabled: false,
};

export default withTranslation()(PrepareDataSaver);
